(function() {
    'use strict';

    angular.module('app').factory('ObjectManager', ['$http', ObjectManager]);

    function ObjectManager($http) {
        return {
            load: load,
        };

        /**
         * Get object/s data
         *
         * @param {string} type - object / group / login / list / hash
         * @param {object} params
         *                 {string} type - group / login
         *                 {int} id - object / group / login
         *                 {string} - hash
         *                 {int} message - history message id
         */
        function load(type, params) {
            var endpoint = '/api-react/object';
            var parameters = params !== void 0 ? params : {};

            switch (type) {
                case 'object':
                    endpoint += '/' + parameters.id;
                    break;
                case 'group':
                    parameters.type = type;
                    parameters.group = parameters.id;
                    break;
                case 'login':
                    parameters.type = type;
                    parameters.login = parameters.id;
                    break;
                case 'list':
                    parameters = {};
                    break;
                default:
                    break;
            }
            delete parameters.id;

            return $http.get(endpoint, { params: parameters }).then(function(response) {
                return response.data.data;
            });
        }
    }
})();
